import { useEffect } from 'react';
import useAnalyticsContext from '|/hooks/use-analytics-context';

const usePurchaseHeaderEvent = () => {
  const { trackEvent } = useAnalyticsContext();

  useEffect(() => {
    trackEvent('carvana-page-load');
  }, [trackEvent]);
};

export default usePurchaseHeaderEvent;
